import * as i0 from '@angular/core';
import { EventEmitter, Output, Input, ViewEncapsulation, Component, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { E11UtilModule } from '@engineering11/ui-lib/e11-ui-utils';

class E11CloserComponent {
    constructor() {
        this.icon = 'close';
        this.size = 'md';
        this.darkMode = false;
        this.close = new EventEmitter();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11CloserComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: E11CloserComponent, selector: "e11-closer", inputs: { classOverrides: "classOverrides", icon: "icon", size: "size", darkMode: "darkMode" }, outputs: { close: "close" }, ngImport: i0, template: `
    <div
      (click)="close.emit()"
      [ngClass]="{
        'e11-h-4 e11-w-4': size === 'sm',
        'e11-h-5 e11-w-5': size === 'md',
        'e11-h-7 e11-w-7': size === 'lg',
        'e11-bg-skin-app-bg-dark e11-border-skin-black hover:e11-text-white': darkMode,
        'e11-bg-skin-white e11-border e11-border-skin-app-borders hover:e11-border-skin-black hover:e11-bg-gray-200 hover:e11-text-skin-dark': !darkMode,
      }"
      class="e11-rounded-full e11-flex e11-items-center e11-justify-center e11-cursor-pointer {{ classOverrides }}"
    >
      <span class="material-icons-outlined" [ngClass]="{ 'md-14': size === 'sm', 'md-18': size === 'md', 'md-24': size === 'lg' }"> close </span>
    </div>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11CloserComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'e11-closer',
                    template: `
    <div
      (click)="close.emit()"
      [ngClass]="{
        'e11-h-4 e11-w-4': size === 'sm',
        'e11-h-5 e11-w-5': size === 'md',
        'e11-h-7 e11-w-7': size === 'lg',
        'e11-bg-skin-app-bg-dark e11-border-skin-black hover:e11-text-white': darkMode,
        'e11-bg-skin-white e11-border e11-border-skin-app-borders hover:e11-border-skin-black hover:e11-bg-gray-200 hover:e11-text-skin-dark': !darkMode,
      }"
      class="e11-rounded-full e11-flex e11-items-center e11-justify-center e11-cursor-pointer {{ classOverrides }}"
    >
      <span class="material-icons-outlined" [ngClass]="{ 'md-14': size === 'sm', 'md-18': size === 'md', 'md-24': size === 'lg' }"> close </span>
    </div>
  `,
                    encapsulation: ViewEncapsulation.None,
                }]
        }], ctorParameters: () => [], propDecorators: { classOverrides: [{
                type: Input
            }], icon: [{
                type: Input
            }], size: [{
                type: Input
            }], darkMode: [{
                type: Input
            }], close: [{
                type: Output
            }] } });

class E11CloserModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11CloserModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: E11CloserModule, declarations: [E11CloserComponent], imports: [CommonModule, E11UtilModule], exports: [E11CloserComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11CloserModule, imports: [CommonModule, E11UtilModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11CloserModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [E11CloserComponent],
                    exports: [E11CloserComponent],
                    imports: [CommonModule, E11UtilModule],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { E11CloserComponent, E11CloserModule };
